import { of, switchMap } from 'rxjs';
import { ofType } from 'redux-observable';
import articleSearchParametersSlice from './slices';

const actions = articleSearchParametersSlice.actions;

export const fetchArticlesEpic = (action$) =>
    action$.pipe(
    ofType(
        actions.updateSearchTermParameter.type,
        actions.updateCategoryNamesParameter.type,
        actions.updatePageParameter.type,
        actions.updatePageSizeParameter.type,
    ),
    switchMap(() => of(actions.fetchArticles()))
);

export const fetchArticlesCountsEpic = (action$) =>
    action$.pipe(
    ofType(
        actions.updateSearchTermParameter.type,
        actions.updateCategoryNamesParameter.type,
    ),
    switchMap(() => of(actions.fetchArticlesCounts()))
);